import { Link } from "@tanstack/react-router";
import truckAsset from "@/assets/truck.png.asset.json";
import logoAsset from "@/assets/logo.png.asset.json";

export function Footer() {
  return (
    <footer className="relative bg-[#030303] pt-24 pb-12 text-zinc-300 border-t border-white/5 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[40rem] h-40 bg-amber-500/10 blur-[120px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="mb-16 flex justify-center">
          <img
            src={truckAsset.url}
            alt="Michael's Painting branded company truck — Interior, Exterior, Commercial, Residential — (608) 886-4598"
            loading="lazy"
            width={1200}
            height={675}
            className="w-full max-w-2xl h-auto drop-shadow-[0_20px_40px_rgba(251,191,36,0.15)]"
          />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <img src={logoAsset.url} alt="Michael's Painting" className="h-12 w-auto" />
            </div>
            <p className="text-sm leading-relaxed text-pretty max-w-sm mb-8 text-zinc-300">
              Madison's trusted residential and commercial painting company for over 30 years. Quality craftsmanship, premium materials, and a 3-year warranty on every project.
            </p>
            <Link
              to="/contact"
              className="inline-flex bg-white text-zinc-950 px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-amber-300 hover:text-white transition-colors"
            >
              Request a Free Estimate
            </Link>
          </div>
          <div className="lg:col-span-2">
            <h5 className="text-white text-[11px] font-semibold uppercase tracking-[0.2em] mb-5">Services</h5>
            <ul className="space-y-3 text-sm">
              <li><Link to="/residential" className="hover:text-white transition-colors">Residential</Link></li>
              <li><Link to="/commercial" className="hover:text-white transition-colors">Commercial</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">All Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-white transition-colors">Portfolio</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h5 className="text-white text-[11px] font-semibold uppercase tracking-[0.2em] mb-5">Service Areas</h5>
            <ul className="space-y-3 text-sm">
              <li>Madison</li>
              <li>Sun Prairie</li>
              <li>Middleton</li>
              <li>Fitchburg</li>
              <li>Verona</li>
              <li>Waunakee</li>
              <li>Stoughton</li>
              <li><Link to="/service-areas" className="hover:text-white transition-colors">View all areas</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h5 className="text-white text-[11px] font-semibold uppercase tracking-[0.2em] mb-5">Contact</h5>
            <ul className="space-y-3 text-sm">
              <li><a href="tel:6088864598" className="hover:text-white transition-colors">(608) 886-4598</a></li>
              <li><a href="mailto:michaelspainting0@gmail.com" className="hover:text-white transition-colors">michaelspainting0@gmail.com</a></li>
              <li>4012 Terminal Dr · McFarland, WI 53558</li>
              <li>Mon–Sat · 8:00 AM – 6:30 PM</li>
            <li className="text-xs text-zinc-300 pt-2">Licensed &amp; Insured · EPA Certified</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 items-center">
          <p className="text-[11px] uppercase tracking-widest text-zinc-300">© {new Date().getFullYear()} Michael's Painting · Serving Madison, WI for 30+ years.</p>
          <p className="text-[11px] uppercase tracking-widest text-zinc-300">All major credit cards accepted</p>
          <a href="https://thestreamlinefactory.com" target="_blank" rel="noopener noreferrer" className="text-[11px] uppercase tracking-widest text-zinc-300 hover:text-white transition-colors">Website By Streamline Factory Inc.</a>
          <div className="flex gap-8 text-[11px] uppercase tracking-widest text-zinc-300">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}